module.exports = __webpack_public_path__ + "assets/img/00115.4ca65a4a.png";